import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './features/userSlice';
import fieldReducer from './features/fieldsSlice';
import companyMasterReducer from './features/companyMasterSlice';
import deleteProfileReducer from './features/deleteProfileSlice';
import imageSlice from './features/imageSlice';
import profileReducer from './features/profileSlice';
import expireReducer from 'redux-persist-expire';
import { persistReducer, persistStore } from 'redux-persist';

const EXPIRE_SECONDS = parseInt(
  process.env.REACT_APP_PERSIST_EXPIRE_SECONDS || '86400',
  10
);

// console.log('EXPIRE_SECONDS:', EXPIRE_SECONDS);

const rootReducer = combineReducers({
  companyMaster: companyMasterReducer,
  deleteProfile: deleteProfileReducer,
  field: fieldReducer,
  user: userReducer,
  image: imageSlice,
  profile: profileReducer,
});

// Transform to persist only profilePicUrlMyDetail from image slice
// const imageSliceTransform = createTransform(
// save only profilePicUrlMyDetail
// (inboundState, key) => {
//   return { profilePicUrlMyDetail: inboundState.profilePicUrlMyDetail };
// },
// rehydrate into full initial state
//   (outboundState, key) => {
//     return {
//       images: [],
//       imageTypes: [],
//       horoscopeImages: [],
//       photoAlbumImages: [],
//       profilePicUrlMyDetail: outboundState.profilePicUrlMyDetail,
//       profilePicUrlMatchDetail: null,
//       profilePhotoImages: [],
//       companyLogoImages: [],
//       loading: false,
//       error: null,
//     };
//   },
//   { whitelist: ['image'] }
// );

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['companyMaster', 'field', 'image'],
  transforms: [
    expireReducer('companyMaster', {
      expireSeconds: EXPIRE_SECONDS,
      expiredState: {},
      autoExpire: true,
    }),
    expireReducer('field', {
      expireSeconds: EXPIRE_SECONDS,
      expiredState: {
        country: [],
        states: [],
        city: [],
        religion: [],
        community: [],
        subCommunity: [],
        weight: [],
        motherTounge: [],
        qualificationType: [],
        highestQualification: [],
        occupation: [],
        annualIncome: [],
        physicalStatus: [],
        dietaryPreferences: [],
        status: 'idle',
        error: null,
        loading: false,
      },
      autoExpire: true,
    }),
    expireReducer('image', {
      expireSeconds: EXPIRE_SECONDS,
      expiredState: {
        images: [],
        imageTypes: [],
        horoscopeImages: [],
        photoAlbumImages: [],
        profilePicUrlMyDetail: null,
        profilePicUrlMatchDetail: null,
        profilePhotoImages: [],
        companyLogoImages: [],
        loading: false,
        error: null,
      },
      autoExpire: true,
    }),
    // imageSliceTransform,
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

// export const store = configureStore({
//   reducer: {
//     user: userReducer,
//     field: fieldsSlice,
//     companyMaster: companyMasterSlice,
//     image: imageSlice,
//     profile: profileReducer,
//   },
// });
